export enum Language {
    Slovenian = 'sl',
    English = 'en',
    Croatian = 'hr'
}
